import i18n, {InitOptions} from 'i18next'
import detector from 'i18next-browser-languagedetector'
import moment from 'moment-timezone'
import {initReactI18next} from 'react-i18next'

import {BackendResolver} from './BackendResolver'

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false
  }
}

const detectorOptions = {
  order: ['localStorage', 'cookie', 'navigator', 'querystring', 'htmlTag', 'path', 'subdomain']
}

const isDevelopment = process.env.NODE_ENV === 'development'

export const Localization = (props: InitOptions = {}) => {
  i18n.on('languageChanged', (lng) => {
    moment.locale(lng)
  })

  const params: InitOptions = {
    returnNull: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    compatibilityJSON: 'v3',
    detection: detectorOptions,
    saveMissing: isDevelopment,
    react: {
      // re-render components when addResourceBundle adds new translations.
      bindI18nStore: 'added'
    },
    ...props
  }
  return i18n.use(BackendResolver).use(detector).use(initReactI18next).init(params)
}
